import { Component, h, Prop, Element, State } from '@stencil/core';
import store from '../../../global/store';
import { BankSearchMode } from '../../../../types/global'; // eslint-disable-line import/extensions

@Component({
  tag: 'ui-bank-search-list',
  styleUrl: 'ui-bank-search-list.scss',
})
export class UiBankSearchList {
  @Element() el: HTMLUiBankSearchListElement;

  @Prop() mode: BankSearchMode = 'regular';

  @State() indexToFocus: number | null = null;

  private observer: IntersectionObserver;

  componentDidLoad() {
    if (this.mode === 'light') {
      store.onChange('resultsVisible', () => {
        if (store.state.resultsVisible.length <= 5) return;
        const hasFullResultPage = store.state.resultsVisible.length % 5 === 0; // Every load more loads up to 5 items
        const indexToFocus = hasFullResultPage
          ? store.state.resultsVisible.length - 5
          : store.state.resultsVisible.length -
            (store.state.resultsVisible.length % 5);

        // This triggers the componentDidUpdate so we can wait for the item to be rendered to focus it
        this.indexToFocus = indexToFocus;
      });
    }
  }

  componentDidUpdate() {
    // has to be called inside componentDidUpdate to make sure the list is already rendered
    // componentDidLoad would be to early because the state in the store is not updated yet
    if (this.mode === 'regular') {
      this.addObserverToReloadItems();
    } else if (this.indexToFocus) {
      const itemToFocus = this.el.querySelectorAll('ui-bank-search-list-item')[
        this.indexToFocus
      ];
      console.log('itemToFocus', itemToFocus);
      const a = itemToFocus
        .querySelector('sd-link')
        .shadowRoot?.querySelector('a');
      a?.focus();
      // Reset the index to focus to null so the componentDidLoad can trigger again
      this.indexToFocus = null;
    }
  }

  private addObserverToReloadItems(): void {
    if (this.observer) this.observer.disconnect(); // prevent multiple observers one same element
    const listItems = Array.from(
      this.el.querySelectorAll('ui-bank-search-list-item') ?? []
    );
    const triggerElement = listItems[listItems.length - 2];
    if (triggerElement) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.observer.disconnect();
              store.state.loadMore();
            }
          });
        },
        { threshold: 1 }
      );
      this.observer.observe(triggerElement);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    return (
      <div class="bank-list" role="list" aria-live="polite">
        {store.state.resultsVisible?.map((bank, index) => (
          <ui-bank-search-list-item
            key={bank.name + index}
            bank={bank}
            index={index}
            mode={this.mode}
          ></ui-bank-search-list-item>
        ))}
      </div>
    );
  }
}
